__turbopack_context__.v({
  "canvasContainer": "pkYU_W_canvasContainer",
  "comingDisclaimer": "pkYU_W_comingDisclaimer",
  "ctaContainer": "pkYU_W_ctaContainer",
  "mainContent": "pkYU_W_mainContent",
  "root": "pkYU_W_root",
});
